import { Wrapper } from 'src/components/Wrapper';
import { Link } from 'src/uikit/Link';

import s from './PromoDevelopers.module.scss';

const MOCK = {
  tag: 'Обучение',
  text: 'Руководство с пошаговыми инструкциями по созданию и запуску frontend-, backend- и full-stack приложений',
};

type PromoDevelopersProps = {
  id?: string;
  link?: string;
};

export function PromoDevelopers(props: PromoDevelopersProps) {
  const { id, link } = props;

  const { tag, text } = MOCK;

  const bannerLink = link ?? 'https://gitverse.containers.cloud.ru/';

  return (
    <section id={id} className={s.root} data-attribute="no_search_index">
      <Wrapper className={s.wrapper}>
        <Link
          className={s.link}
          href={bannerLink}
          id={`developers-banner`}
          analyticsOptions={{
            action: bannerLink,
            clickZone: 'body',
            clickElement: 'cardclick',
            clickContent: MOCK.text,
            uniqueId: `product-banner-${MOCK.text}`,
            transitionType: 'inside-link',
          }}
        >
          <div className={s.content}>
            <span className={s.tag}>{tag}</span>

            <p className={s.text} dangerouslySetInnerHTML={{ __html: text }} />
          </div>
        </Link>
      </Wrapper>
    </section>
  );
}
